export const uiSection = {
    name: 'UI Section',
    description: '',
    displayField: 'title',
    fields: {
        title: {
            name: 'Title',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        elementId: {
            name: 'Element Id',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        columns: {
            name: 'Columns',
            type: 'Array',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [],
            items: {
                type: 'Link',
                validations: [{ linkContentType: ['uiColumn'] }],
                linkType: 'Entry'
            }
        },
        verticalAlign: {
            name: 'Vertical Align',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ in: ['Center', 'Top', 'Bottom'] }]
        },
        background: {
            name: 'Background',
            type: 'Object',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        sectionBackground: {
            name: 'Section background',
            type: 'Object',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        }
    }
};
//# sourceMappingURL=uiSection.js.map